document.addEventListener('DOMContentLoaded', function() {
  var selectTriggers = document.querySelectorAll('.custom-select-trigger');
  var fileInput = document.getElementById('feedback-file');
  var fileListContainer = document.getElementById('file-list');
  var fileArray = [];
  var feedbackForm = document.getElementById('feedback-form');
  var floatingTab = document.getElementById('floating-tab');
  var closeButton = document.getElementById('feedback-form-close');

  // Select the open-popup-button element
  var openPopupButton = document.querySelector('.open-popup-button');

  // Dropdown functionality
  selectTriggers.forEach(trigger => {
    trigger.addEventListener('click', function() {
      var selectContainer = this.closest('.custom-select');
      var selectOptions = selectContainer.querySelector('.custom-select-options');
      
      if (selectOptions.classList.contains('open')) {
        selectOptions.classList.remove('open');
      } else {
        document.querySelectorAll('.custom-select-options').forEach(options => {
          options.classList.remove('open');
        });
        selectOptions.classList.add('open');
      }
    });
  });

  // Handle option click
  document.querySelectorAll('.custom-select-option').forEach(option => {
    option.addEventListener('click', function() {
      var value = this.getAttribute('data-value');
      var selectContainer = this.closest('.custom-select');
      var selectTrigger = selectContainer.querySelector('.custom-select-trigger');
      var feedbackTypeInput = document.getElementById('feedback-type');
      
      if (feedbackTypeInput) {
        feedbackTypeInput.value = value; // Update hidden input value
      } else {
        console.error('Feedback type input not found in the DOM');
      }
  
      // Update the trigger text with the selected option
      selectTrigger.textContent = this.textContent;
      
      // Remove the open class to hide options
      selectContainer.querySelector('.custom-select-options').classList.remove('open');
    });
  });

  // Close dropdown if clicked outside
  document.addEventListener('click', function(event) {
    if (!event.target.closest('.custom-select')) {
      document.querySelectorAll('.custom-select-options').forEach(options => {
        options.classList.remove('open');
      });
    }
  });

  // File input functionality
  function updateFileList() {
    fileListContainer.innerHTML = ''; // Clear the file list container
  
    fileArray.forEach((file, index) => {
      var fileItem = document.createElement('div');
      fileItem.className = 'file-item';
      fileItem.textContent = file.name;
  
      var removeButton = document.createElement('button');
      removeButton.className = 'remove-file';
      removeButton.textContent = 'x';
  
      removeButton.addEventListener('click', function(event) {
        event.stopPropagation(); // Prevent the click from bubbling up
  
        fileArray.splice(index, 1); // Use index to correctly remove the item
        updateFileList(); // Update the file list display
  
        updateFileInput();
        updateFileLabel();
      });
  
      fileItem.appendChild(removeButton);
      fileListContainer.appendChild(fileItem);
    });
  
    updateFileLabel();
  }

  function updateFileLabel() {
    var fileCount = fileArray.length;
    var label = document.querySelector('.custom-file-upload span'); // Ensure correct span is targeted
    if (fileCount > 0) {
      label.textContent = `${fileCount} file(s) selected`;
    } else {
      label.textContent = 'Upload supporting documents';
    }
  }

  function updateFileInput() {
    var dataTransfer = new DataTransfer();
    fileArray.forEach(file => dataTransfer.items.add(file));
    fileInput.files = dataTransfer.files;
  }

  function resetFileInput() {
    fileArray = [];
    updateFileList();
    updateFileLabel();
    
    var newFileInput = fileInput.cloneNode(true);
    fileInput.parentNode.replaceChild(newFileInput, fileInput);
    fileInput = newFileInput;
  
    fileInput.addEventListener('change', handleFileInputChange);
  }

  function handleFileInputChange() {
    Array.from(fileInput.files).forEach(file => {
      if (!fileArray.some(f => f.name === file.name)) {
        fileArray.push(file);
      }
    });
  
    updateFileList();
    fileInput.value = ''; 
  }

  // Initial event listener attachment
  fileInput.addEventListener('change', handleFileInputChange);

  // Form handling
  function toggleFeedbackForm(event) {
    if (event) {
      event.preventDefault();
    }
    var isOpen = feedbackForm.classList.contains('open');

    if (isOpen) {
      // Close the form
      feedbackForm.classList.remove('open');
      floatingTab.style.transform = 'translateX(0)';
      
      // Show the open-popup-button
      if (openPopupButton) {
        openPopupButton.style.opacity = '1'; // Set opacity back to 1
      }

      setTimeout(() => {
        feedbackForm.style.display = 'none';
        if (window.innerWidth < 750) {
          floatingTab.style.display = 'block'; // Ensure tab is visible on smaller screens
        }
      }, 300);
    } else {
      // Open the form
      feedbackForm.style.display = 'block';
      setTimeout(() => {
        feedbackForm.classList.add('open');
        floatingTab.style.transform = 'translateX(-60rem)';
        
        // Hide the open-popup-button
        if (openPopupButton) {
          openPopupButton.style.opacity = '0'; // Set opacity to 0
        }

        if (window.innerWidth < 750) {
          floatingTab.style.display = 'none'; // Hide tab on smaller screens
        }
      }, 10);
    }
  }

  // Ensure toggleFeedbackForm is globally accessible
  window.toggleFeedbackForm = toggleFeedbackForm;

  // Attach click event to #floating-tab to toggle feedback form
  floatingTab.addEventListener('click', function(event) {
    toggleFeedbackForm(event); // Pass event to toggleFeedbackForm
  });

  closeButton.addEventListener('click', function(event) {
    toggleFeedbackForm(event); // Use the same toggle function to close the form
  });

  document.addEventListener('click', function(event) {
    var isFormOpen = feedbackForm.classList.contains('open');

    if (isFormOpen && !feedbackForm.contains(event.target) && !floatingTab.contains(event.target)) {
      toggleFeedbackForm(event); // Use the same toggle function to close the form
    }
  });

  // Handle screen size changes
  window.addEventListener('resize', function() {
    if (window.innerWidth >= 750) {
      floatingTab.style.display = 'block'; // Ensure tab is visible on larger screens
    } else if (feedbackForm.classList.contains('open')) {
      floatingTab.style.display = 'none'; // Hide tab when form is open on smaller screens
    }
  });
});
